import React, { useState, useEffect } from "react";
import {
    makeStyles,
    useTheme,
    Paper,
    Grid,
    TextField,
    Table,
    TableHead,
    TableBody,
    Card,
    Typography,
    CardContent,
    CardActions,
    TableCell,
    TableRow,
    IconButton,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from "@material-ui/core";
import { Formik, Form, Field } from 'formik';
import ButtonWithSpinner from "../ButtonWithSpinner";
import ConfirmationModal from "../ConfirmationModal";

import Switch from "@material-ui/core/Switch";


import { Edit as EditIcon } from "@material-ui/icons";

import { toast } from "react-toastify";
import usePlans from "../../hooks/usePlans";
import { i18n } from "../../translate/i18n";
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
  },
  switchContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  switchLabel: {
    marginTop: theme.spacing(1),
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  },
    mainPaper: {
        width: '100%',
        flex: 1,
        padding: theme.spacing(2)
    },
    fullWidth: {
        width: '100%'
    },
    tableContainer: {
        width: '100%',
        overflowX: "scroll",
        ...theme.scrollbarStyles
    },
    textfield: {
        width: '100%'
    },
    textRight: {
        textAlign: 'right'
    },
    row: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    control: {
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1)
    },
    buttonContainer: {
        textAlign: 'right',
        padding: theme.spacing(1)
    }
}));

export function PlanManagerForm(props) {
    const { onSubmit, onDelete, onCancel, initialValue, loading } = props;
    const classes = useStyles();
    const theme = useTheme();

    const [record, setRecord] = useState({
        name: '',
        users: 0,
        connections: 0,
        queues: 0,
        amount: 0,
        useWhatsapp: true,
        useFacebook: true,
        useInstagram: true,
        useCampaigns: true,
        useSchedules: true,
        useInternalChat: true,
        useExternalApi: true,
        useKanban: true,
        useOpenAi: true,
        useIntegrations: true,
        isPublic: true
    });

    useEffect(() => {
        setRecord(initialValue)
    }, [initialValue])

    const handleSubmit = async (data) => {
        onSubmit(data)
    }

    return (
        <Formik
            enableReinitialize
            className={classes.fullWidth}
            initialValues={record}
            onSubmit={(values, { resetForm }) =>
                setTimeout(() => {
                    handleSubmit(values)
                    resetForm()
                }, 500)
            }
        >
            {(values) => (
                <Form className={classes.fullWidth}>
                    <Grid spacing={1} justifyContent="flex-start" container>
                        {/* NOME */}
                        <Grid container spacing={3} style={{ padding: "16px" }}>
  {/* Nome */}
  <Grid item xs={12} sm={6} md={3} xl={2}>
    <Field
      as={TextField}
      label={i18n.t("Nome do Plano")}
      name="name"
      variant="outlined"
      margin="dense"
      fullWidth
      InputLabelProps={{ style: { fontWeight: "bold" } }}
      style={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "8px",
      }}
    />
  </Grid>

  {/* Público */}
  <Grid item xs={12} sm={6} md={3} xl={2}>
    <FormControl
      variant="outlined"
      margin="dense"
      fullWidth
      style={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "8px",
      }}
    >
      <InputLabel
        htmlFor="status-selection"
        style={{ fontWeight: "bold" }}
      >
        {i18n.t("plans.form.public")}
      </InputLabel>
      <Field as={Select} id="status-selection" name="isPublic" margin="dense">
        <MenuItem value={true}>Sim</MenuItem>
        <MenuItem value={false}>Não</MenuItem>
      </Field>
    </FormControl>
  </Grid>

  {/* Usuários */}
  <Grid item xs={12} sm={6} md={2}>
    <Field
      as={TextField}
      label={i18n.t("plans.form.users")}
      name="users"
      variant="outlined"
      margin="dense"
      type="number"
      fullWidth
      InputLabelProps={{ style: { fontWeight: "bold" } }}
      style={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "8px",
      }}
    />
  </Grid>

  {/* Conexões */}
  <Grid item xs={12} sm={6} md={2}>
    <Field
      as={TextField}
      label={i18n.t("plans.form.connections")}
      name="connections"
      variant="outlined"
      margin="dense"
      type="number"
      fullWidth
      InputLabelProps={{ style: { fontWeight: "bold" } }}
      style={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "8px",
      }}
    />
  </Grid>

  {/* Filas */}
  <Grid item xs={12} sm={6} md={2}>
    <Field
      as={TextField}
      label="Filas"
      name="queues"
      variant="outlined"
      margin="dense"
      type="number"
      fullWidth
      InputLabelProps={{ style: { fontWeight: "bold" } }}
      style={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "8px",
      }}
    />
  </Grid>

  {/* Valor */}
  <Grid item xs={12} sm={6} md={2}>
    <Field
      as={TextField}
      label="Valor"
      name="amount"
      variant="outlined"
      margin="dense"
      type="text"
      fullWidth
      InputLabelProps={{ style: { fontWeight: "bold" } }}
      style={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "8px",
        fontWeight: "bold",
      }}
    />
  </Grid>
</Grid>

<Grid container spacing={3} style={{ marginTop: "16px" }}>
{/* WHATSAPP */}
<Grid xs={12} sm={6} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useWhatsapp-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                Whatsapp
            </label>
            <Field name="useWhatsapp">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useWhatsapp-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useWhatsapp", e.target.checked)}
                            color="primary"
                        />
                        <span
                            className={classes.switchLabel}
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: theme.palette.text.secondary,
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* FACEBOOK */}
<Grid xs={12} sm={6} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useFacebook-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                Facebook
            </label>
            <Field name="useFacebook">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useFacebook-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useFacebook", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* INSTAGRAM */}
<Grid xs={12} sm={6} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useInstagram-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                Instagram
            </label>
            <Field name="useInstagram">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useInstagram-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useInstagram", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* CAMPANHAS */}
<Grid xs={12} sm={6} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useCampaigns-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                {i18n.t("plans.form.campaigns")}
            </label>
            <Field name="useCampaigns">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useCampaigns-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useCampaigns", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* AGENDAMENTOS */}
<Grid xs={12} sm={8} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useSchedules-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                {i18n.t("plans.form.schedules")}
            </label>
            <Field name="useSchedules">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useSchedules-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useSchedules", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* CHAT INTERNO */}
<Grid xs={12} sm={8} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useInternalChat-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                Chat Interno
            </label>
            <Field name="useInternalChat">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useInternalChat-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useInternalChat", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* API Externa */}
<Grid xs={12} sm={8} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useExternalApi-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                API Externa
            </label>
            <Field name="useExternalApi">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useExternalApi-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useExternalApi", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* CRM Kanban */}
<Grid xs={12} sm={8} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useKanban-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                CRM Kanban
            </label>
            <Field name="useKanban">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useKanban-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useKanban", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* Open.AI */}
<Grid xs={12} sm={8} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useOpenAi-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                Open.AI
            </label>
            <Field name="useOpenAi">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useOpenAi-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useOpenAi", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>

{/* Integrações */}
<Grid xs={12} sm={8} md={2} item>
    <FormControl
        margin="dense"
        variant="outlined"
        fullWidth
        style={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "8px",
            padding: "16px",
            textAlign: "center",
        }}
    >
        <div>
            <label
                htmlFor="useIntegrations-switch"
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                }}
            >
                Integrações
            </label>
            <Field name="useIntegrations">
                {({ field, form }) => (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Switch
                            id="useIntegrations-switch"
                            checked={field.value}
                            onChange={(e) => form.setFieldValue("useIntegrations", e.target.checked)}
                            color="primary"
                        />
                        <span
                            style={{
                                marginTop: "8px",
                                fontSize: "0.875rem",
                                color: "#555",
                            }}
                        >
                            {i18n.t(field.value ? "plans.form.enabled" : "plans.form.disabled")}
                        </span>
                    </div>
                )}
            </Field>
        </div>
    </FormControl>
</Grid>
</Grid>
  </Grid>

                    <Grid spacing={2} justifyContent="flex-end" container>

                        <Grid sm={3} md={2} item>
                            <ButtonWithSpinner
                              startIcon={<CancelIcon />}
                              style={{
                              color: "white",
                              backgroundColor: "#8A2BE2",
                              boxShadow: "none",
                              borderRadius: "5px",
                              fontSize: "12px",
                              }}
                              className={classes.fullWidth}
                              loading={loading}
                              onClick={() => onCancel()}
                              variant="contained"
                               >
                                {i18n.t("plans.form.clear")}
                            </ButtonWithSpinner>
                        </Grid>
                        {record.id !== undefined ? (
                            <Grid sm={3} md={2} item>
                                <ButtonWithSpinner
                                 startIcon={<DeleteIcon />}
                                 className={classes.fullWidth}
                                 loading={loading} onClick={() => onDelete(record)}
                                 variant="contained"
                                 style={{
                                 color: "white",
                                 backgroundColor: "#db6565",
                                 boxShadow: "none",
                                 borderRadius: "5px",
                                 fontSize: "12px",
                                 }}
                                   >
                                    {i18n.t("plans.form.delete")}
                                </ButtonWithSpinner>
                            </Grid>
                        ) : null}
                        <Grid sm={3} md={2} item>
                            <ButtonWithSpinner
                             startIcon={<SaveIcon />}
                             className={classes.fullWidth}
                             loading={loading}
                             type="submit" 
                             variant="contained"
                             style={{
                             color: "white",
                             backgroundColor: "#8E2DE2",
                             boxShadow: "none",
                             borderRadius: "5px",
                             fontSize: "12px",
                             }}
                               >
                                {i18n.t("plans.form.save")}
                            </ButtonWithSpinner>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    )
}

export function PlansManagerGrid(props) {
    const { records, onSelect } = props
    const classes = useStyles()
    const theme = useTheme();

    const renderWhatsapp = (row) => {
        return row.useWhatsapp === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderFacebook = (row) => {
        return row.useFacebook === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderInstagram = (row) => {
        return row.useInstagram === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderCampaigns = (row) => {
        return row.useCampaigns === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderSchedules = (row) => {
        return row.useSchedules === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderInternalChat = (row) => {
        return row.useInternalChat === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderExternalApi = (row) => {
        return row.useExternalApi === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderKanban = (row) => {
        return row.useKanban === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderOpenAi = (row) => {
        return row.useOpenAi === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    const renderIntegrations = (row) => {
        return row.useIntegrations === false ? `${i18n.t("plans.form.no")}` : `${i18n.t("plans.form.yes")}`;
    };

    return (
<Grid container spacing={3}>
    {records.map((row) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={row.id}>
            <Card
                style={{
                    backgroundColor: theme.palette.background.paper,
                    border: `1px solid ${theme.palette.divider}`,
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    borderRadius: "10px",
                    padding: "20px",
                    margin: "10px",
                    transition: "transform 0.2s ease-in-out",
                    cursor: "pointer",
                       }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                <CardContent style={{ padding: "16px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    {/* Valor destacado no topo */}
                    <Typography
                        variant="h4"
                        style={{
                            fontWeight: "bold",
                            color: "#6517ab",
                            marginBottom: "16px",
                            textAlign: "center",
                        }}
                    >
                        {i18n.t("plans.form.money")} {row.amount ? row.amount.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : "00.00"}
                    </Typography>
                    
                    {/* Nome do plano */}
                    <Typography
                        variant="h6"
                        style={{
                            fontWeight: "bold",
                            color: theme.palette.text.primary,
                            marginBottom: "8px",
                            textAlign: "center",
                        }}
                    >
                        {row.name || "-"}
                    </Typography>

                    {/* Outros campos, exibidos verticalmente */}
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        {i18n.t("plans.form.users")}: {row.users || "-"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        {i18n.t("plans.form.public")}: {row.isPublic ? "Sim" : "Não"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        {i18n.t("plans.form.connections")}: {row.connections || "-"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Filas: {row.queues || "-"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Whatsapp: {renderWhatsapp(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Facebook: {renderFacebook(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Instagram: {renderInstagram(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        {i18n.t("plans.form.campaigns")}: {renderCampaigns(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        {i18n.t("plans.form.schedules")}: {renderSchedules(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Chat Interno: {renderInternalChat(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        API Externa: {renderExternalApi(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Kanban: {renderKanban(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Open.AI: {renderOpenAi(row)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: "8px" }}>
                        Integrações: {renderIntegrations(row)}
                    </Typography>
                </CardContent>
                <CardActions style={{ padding: "8px 16px", justifyContent: "flex-end" }}>
                    <IconButton
                        onClick={() => onSelect(row)}
                        aria-label="edit"
                        style={{
                        backgroundColor: "#3DB8FF",
                        borderRadius: "10px",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "0.3s",
                       }}
                    >
                        <EditIcon style={{ color: "#fff" }}/>
                    </IconButton>
                </CardActions>
            </Card>
        </Grid>
    ))}
</Grid>
   )
}

export default function PlansManager() {
    const classes = useStyles();
    const theme = useTheme();
    const { list, save, update, remove } = usePlans()

    const [showConfirmDialog, setShowConfirmDialog] = useState(false)
    const [loading, setLoading] = useState(false)
    const [records, setRecords] = useState([])
    const [record, setRecord] = useState({
        name: '',
        users: 0,
        connections: 0,
        queues: 0,
        amount: 0,
        useWhatsapp: true,
        useFacebook: true,
        useInstagram: true,
        useCampaigns: true,
        useSchedules: true,
        useInternalChat: true,
        useExternalApi: true,
        useKanban: true,
        useOpenAi: true,
        useIntegrations: true,
        isPublic: true
    })

    useEffect(() => {
        async function fetchData() {
            await loadPlans()
        }
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [record])

    const loadPlans = async () => {
        setLoading(true)
        try {
            const planList = await list()
            setRecords(planList)
        } catch (e) {
            toast.error('Não foi possível carregar a lista de registros')
        }
        setLoading(false)
    }

    const handleSubmit = async (data) => {
        setLoading(true)
        console.log(data)
        try {
            if (data.id !== undefined) {
                await update(data)
            } else {
                await save(data)
            }
            await loadPlans()
            handleCancel()
            toast.success('Operação realizada com sucesso!')
        } catch (e) {
            toast.error('Não foi possível realizar a operação. Verifique se já existe uma plano com o mesmo nome ou se os campos foram preenchidos corretamente')
        }
        setLoading(false)
    }

    const handleDelete = async () => {
        setLoading(true)
        try {
            await remove(record.id)
            await loadPlans()
            handleCancel()
            toast.success('Operação realizada com sucesso!')
        } catch (e) {
            toast.error('Não foi possível realizar a operação')
        }
        setLoading(false)
    }

    const handleOpenDeleteDialog = () => {
        setShowConfirmDialog(true)
    }

    const handleCancel = () => {
        setRecord({
            id: undefined,
            name: '',
            users: 0,
            connections: 0,
            queues: 0,
            amount: 0,
            useWhatsapp: true,
            useFacebook: true,
            useInstagram: true,
            useCampaigns: true,
            useSchedules: true,
            useInternalChat: true,
            useExternalApi: true,
            useKanban: true,
            useOpenAi: true,
            useIntegrations: true,
            isPublic: true
        })
    }

    const handleSelect = (data) => {

        let useWhatsapp = data.useWhatsapp === false ? false : true
        let useFacebook = data.useFacebook === false ? false : true
        let useInstagram = data.useInstagram === false ? false : true
        let useCampaigns = data.useCampaigns === false ? false : true
        let useSchedules = data.useSchedules === false ? false : true
        let useInternalChat = data.useInternalChat === false ? false : true
        let useExternalApi = data.useExternalApi === false ? false : true
        let useKanban = data.useKanban === false ? false : true
        let useOpenAi = data.useOpenAi === false ? false : true
        let useIntegrations = data.useIntegrations === false ? false : true

        setRecord({
            id: data.id,
            name: data.name || '',
            users: data.users || 0,
            connections: data.connections || 0,
            queues: data.queues || 0,
            amount: data.amount?.toLocaleString('pt-br', { minimumFractionDigits: 2 }) || 0,
            useWhatsapp,
            useFacebook,
            useInstagram,
            useCampaigns,
            useSchedules,
            useInternalChat,
            useExternalApi,
            useKanban,
            useOpenAi,
            useIntegrations,
            isPublic: data.isPublic
        })
    }

    return (
        <Paper className={classes.mainPaper} elevation={0}>
            <Grid spacing={2} container>
                <Grid xs={12} item>
                    <PlanManagerForm
                        initialValue={record}
                        onDelete={handleOpenDeleteDialog}
                        onSubmit={handleSubmit}
                        onCancel={handleCancel}
                        loading={loading}
                    />
                </Grid>
                <Grid xs={12} item>
                    <PlansManagerGrid
                        records={records}
                        onSelect={handleSelect}
                    />
                </Grid>
            </Grid>
            <ConfirmationModal
                title="Exclusão de Registro"
                open={showConfirmDialog}
                onClose={() => setShowConfirmDialog(false)}
                onConfirm={() => handleDelete()}
            >
                Deseja realmente excluir esse registro?
            </ConfirmationModal>
        </Paper>
    )
}